import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TabletOutlinedSvg from "@ant-design/icons-svg/es/asn/TabletOutlined";
import AntdIcon from "../components/AntdIcon";
var TabletOutlined = function TabletOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TabletOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TabletOutlined.displayName = 'TabletOutlined';
}
export default /*#__PURE__*/React.forwardRef(TabletOutlined);